export const parseKingTableUrl = (
    url: string
):
    | { restaurant: string, table: string, terrace: string, token: string }
    | typeof undefined => {
    const parsedResult = new URL(url).searchParams
    if (
        !parsedResult.has('restaurant') ||
        !parsedResult.has('table') ||
        !parsedResult.has('token')
    ) {
        return
    }
    return {
        restaurant: parsedResult.get('restaurant') || '',
        table: parsedResult.get('table') || '',
        terrace: parsedResult.get('terrace') || 'false',
        token: parsedResult.get('token') || ''
    }
}
